import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';
import SeoHelmet from "../components/SeoHelmet";
const Oneonone = () => {
 

const [activeVideo, setActiveVideo] = useState(null);
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: ""
});

    
      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };

       
    
      const handleRazorpayPayment = (courseType) => {

        if (!formData.name.trim()) {
          alert("Please enter your name.");
          return;
        }
        if (!formData.email.trim()) {
          alert("Please enter your email.");
          return;
        }
        if (!formData.phone.trim()) {
          alert("Please enter your phone number.");
          return;
        }
        const amount = courseType === "online" ? 50000 : 100000; // ₹500 for online, ₹1000 for offline
        const description = courseType === "online" ? "Online Course" : "Offline Course";

        const options = {
          key: "rzp_live_RqikICjLlTbO4w", // Replace with your Razorpay Key ID
          amount: amount * 100, // Amount in paise (1000 = ₹10)
          currency: "INR",
          name: "Bhavana Singh Courses",
          description: description,
          //image: "https://your-logo-url.com/logo.png", // Replace with your company logo URL
          handler: function (response) {
            const paymentId = response.razorpay_payment_id;
            //alert(`Payment successful. Payment ID: ${paymentId}`);
            window.location.href = `/success?payment_id=${paymentId}`;
          },
          prefill: {
            name: formData.name,
            email: formData.email,
            contact: formData.phone,
          },
          notes: {
            address: "Bhavana Singh",
          },
          theme: {
            color: "#3399cc",
          },
        };
    
        const razorpay = new window.Razorpay(options);
        razorpay.on("payment.failed", function (response) {
          alert(`Payment failed. Error: ${response.error.description}`);
        });
        razorpay.open();
      };


  const courses = {
    1: { title: "First Post", content: ( 
      <>
      
      </>
      ), },
    2: { title: "Second Post", content: ( 
      <>
      
      
      </>
      ), },
  };

 

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 


  return (
    <>
 <SeoHelmet />
    <section class="courses_details">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                        <h3>Be the Best Version Of</h3>
                        <h2>yourself!</h2>
                        <p>These tailor-made sessions focus on every aspect of your personal style and confidence, from your wardrobe and grooming to your body language and communication skills. With Bhavana’s expert guidance, you’ll embark on a journey to discover your most confident and polished self. Bhavana helps you become the best version of yourself, transforming you from ordinary to extraordinary. Eventually, you’ll have the confidence to own any room you walk into.</p>
                        <h4>What’s Included in Your Transformation Journey?</h4>
                        <div class="listcontent">
                            <div class="accordion" id="accordionExample">
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                 Day 1: Personalized Consultation
                                </h4>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <ul>
                                    <li>In-depth consultation to understand your lifestyle, goals, and unique needs.</li>
                                    <li>Identification of problem areas and areas for improvement.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                 
                                Day 2: Guided Shopping
                                  
                                </h4>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                 
                                  <ul>
                                    <li>Exclusive shopping session for makeup, skincare, and accessories.</li>
                                    <li>Recommendations tailored to your style, preferences, and personality.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingThree" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                 
                                Day 3: Skincare, Makeup & Confidence Training
                                  
                                </h4>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                 
                                  <ul>
                                    
                                    <li>Hands-on practice with skincare routines and makeup techniques.</li>
                                    <li>Mastering body language and posture for a confident presence.</li>
                                  </ul>
                                  
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingfor" data-bs-toggle="collapse" data-bs-target="#collapsefor" aria-expanded="false" aria-controls="collapsefor">
                                 
                                Day 4: Wardrobe Building
                                  
                                </h4>
                                <div id="collapsefor" class="accordion-collapse collapse" aria-labelledby="headingfor" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  
                                  <ul>
                                    <li>Guided shopping for outfits, lingerie, boots, sunglasses, and more.</li>
                                    <li>Personalized styling advice to align with your body type and personality.</li>
                                  </ul>
                                  
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="courses_image">
                        <img src={Couimg} alt="" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section class="courses_details onepagecontent">
        <div class="container">
            <div class="row">
            <div class="col-md-6">
                    <div class="courses_image imgcoud">
                        <img src={Couimgg} alt="" width="100%" />
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                      
                        <h4>What You Will Gain</h4>
                        <p>These tailor-made sessions focus on every aspect of your personal style and confidence, from your wardrobe and grooming to your body language and communication skills. With Bhavana’s expert guidance, you’ll embark on a journey to discover your most confident and polished self. Bhavana helps you become the best version of yourself, transforming you from ordinary to extraordinary. Eventually, you’ll have the confidence to own any room you walk into.</p>
                      
                        <ul className="secmbr">
                            <li><b>Enhanced Confidence:</b> Learn how to carry yourself with poise and assurance.</li>
                            <li><b>Refined Style:</b> Discover what works best for your hair, skin, body type,   and wardrobe.</li>
                            <li><b>Communication Skills:</b> Improve your speaking and interpersonal skills.</li>
                            <li><b>Polished Presence:</b> Build a lasting impression through your overall appearance and demeanour.</li>
                            <li><b>Extraordinary Transformation:</b> Transition from ordinary to extraordinary and gain the confidence to own every room you walk into.</li>
                        </ul>

                        <div class="courses_contentt">
                            <h4>The Unique Approach</h4>
                            <p>With years of experience transforming personalities and empowering individuals, Bhavana Singh’s practical, hands-on approach ensures you get the most out of every session. She combines her expertise in fashion, grooming, and personal development to create a transformation plan tailored just for you.</p>
                        </div>
                    </div>
                   
                </div>
                
            </div>
        </div>
      </section>
      <section class="courses_sli">
        <div class="container">
            <div class="courses-slide">
                <div class="slide_head">
                    <h3>TRANSFORMATION IN FOCUS </h3>
                    <h2>Sneak Peek and Success Stories</h2>
                    <p>Get a firsthand look at the journey with real moments captured from our live sessions. Watch as confidence builds, style transforms, and true presence unfolds. These reels offer a glimpse into the powerful impact of our program in action.</p>
                </div>
            </div>
            <div class="swiper coursesslide">
            <div class="swiper-wrapper">
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image1}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image2}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image3}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image4}/><img className='playbtnv' src={Playbtn}></img></a></div>
                   
                </div>
            </div>
            <div class="courses_btn">
                <a href="#" data-bs-toggle="modal" data-bs-target="#onlineCourseModal">Enrol Now</a>
                <a >Download Brochure</a>
            </div>
        </div>
      </section>

    <div className="modal fade" id="offlineCourseModal" tabIndex="-1" aria-labelledby="offlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("offline")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="onlineCourseModal" tabIndex="-1" aria-labelledby="onlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Online Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("online")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">Bhavana Singh</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Oneonone;
